<div class="bg-shui-base-1 rounded-md box-border">
    <p class="text-base text-shui-text-moderate font-semibold m-0 mb-2 p-0">
        {{ 'request.overview.iro-overview' | translate }}
    </p>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-shui-base-2 p-4 rounded-md col-span-2">
            <div class="flex items-center justify-between mb-2">
                <p class="text-base text-shui-text-moderate font-semibold m-0 p-0">
                    {{ 'request.overview.customer-information' | translate }}
                </p>
                <sh-button
                    [label]="'common.edit' | translate"
                    size="small"
                    color="tertiary"
                    (click)="onEditStep(1)"
                ></sh-button>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.customer-name' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()?.customerName ?? '—'
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.quote-contract-number' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()?.quoteContractNumber ?? '—'
                    }}</span>
                </div>
                @if (dealType() === DealType.INSTRUMENT_ONLY) {
                    <div class="flex flex-col gap-0">
                        <span class="text-xs text-shui-text-subtle">{{
                            'request.overview.product-line' | translate
                        }}</span>
                        <span class="text-sm text-shui-text-strong font-medium">{{
                            'request.product-lines.' + productLine() | translate
                        }}</span>
                    </div>
                    <div class="flex flex-col gap-0">
                        <span class="text-xs text-shui-text-subtle">{{
                            'request.overview.ship-to-number' | translate
                        }}</span>
                        <span class="text-sm text-shui-text-strong font-medium">{{ shipToNumber() ?? '—' }}</span>
                    </div>
                    <div class="flex flex-col gap-0">
                        <span class="text-xs text-shui-text-subtle">{{
                            'request.overview.sold-to-number' | translate
                        }}</span>
                        <span class="text-sm text-shui-text-strong font-medium">{{ soldToNumber() ?? '—' }}</span>
                    </div>
                }
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.ship-to-address' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()?.shipToAddress ?? '—'
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.sold-to-address' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()?.soldToAddress ?? '—'
                    }}</span>
                </div>
            </div>
        </div>
        <div class="bg-shui-base-2 p-4 rounded-md col-span-2">
            <div class="flex items-center justify-between mb-2">
                <p class="text-base text-shui-text-moderate font-semibold m-0 p-0">
                    {{ 'request.overview.materials' | translate }}
                </p>
                <sh-button
                    [label]="'common.edit' | translate"
                    size="small"
                    color="tertiary"
                    (click)="onEditStep(1)"
                ></sh-button>
            </div>
            <div class="w-full h-[400px]">
                <ag-grid-angular
                    [gridOptions]="gridOptions"
                    [rowData]="materials()"
                    [columnDefs]="colDefs()"
                    class="w-full h-full"
                />
            </div>
        </div>
        <div class="bg-shui-base-2 p-4 rounded-md">
            <div class="flex items-center justify-between mb-2">
                <p class="text-base text-shui-text-moderate font-semibold m-0 p-0">
                    {{ 'request.overview.contacts' | translate }}
                </p>
                <sh-button
                    [label]="'common.edit' | translate"
                    size="small"
                    color="tertiary"
                    (click)="onEditStep(3)"
                ></sh-button>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{ 'request.overview.customer' | translate }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        contactData()?.customerEmail ?? '—'
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{ 'request.overview.tas' | translate }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{ contactData()?.tasEmail ?? '—' }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{ 'request.overview.sales-rep' | translate }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        contactData()?.salesRepEmail ?? '—'
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.project-manager' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        contactData()?.pmInstallationEmail ?? '—'
                    }}</span>
                </div>
            </div>
            @if (contactData()?.additionalContacts?.length) {
                <div class="flex flex-col gap-1 mt-2">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.additional-contacts' | translate
                    }}</span>
                    @for (contact of contactData()!.additionalContacts; track $index) {
                        <span class="text-sm text-shui-text-strong font-medium">
                            @if (contact.title && contact.email) {
                                {{ contact.title }} ({{ contact.email }})
                            } @else {
                                {{ contact.title ?? contact.email ?? '—' }}
                            }
                        </span>
                    }
                </div>
            }
        </div>
        <div class="bg-shui-base-2 p-4 rounded-md">
            <div class="flex items-center justify-between mb-2">
                <p class="text-base text-shui-text-moderate font-semibold m-0 p-0">
                    {{ 'request.overview.additional-details' | translate }}
                </p>
                <sh-button
                    [label]="'common.edit' | translate"
                    size="small"
                    color="tertiary"
                    (click)="onEditStep(2)"
                ></sh-button>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.distributor-account' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">
                        @if (orderDetailsData()?.isDistributor) {
                            {{ 'common.yes' | translate }} — {{ orderDetailsData()?.distributorName ?? '—' }}
                        } @else if (orderDetailsData()?.isDistributor === false) {
                            {{ 'common.no' | translate }}
                        } @else {
                            —
                        }
                    </span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{ 'request.overview.cpr-contact' | translate }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">
                        @if (orderDetailsData()?.isCprContract === true) {
                            {{ 'common.yes' | translate }}
                        } @else if (orderDetailsData()?.isCprContract === false) {
                            {{ 'common.no' | translate }}
                        } @else {
                            —
                        }
                    </span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.months-of-inventory' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        orderDetailsData()?.monthsOfInventory ?? '—'
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'request.overview.mdla-notification-emails' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">
                        @if (orderDetailsData()?.additionalEmails?.length) {
                            {{ orderDetailsData()!.additionalEmails!.join(', ') }}
                        } @else {
                            —
                        }
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="w-full h-px bg-shui-base-4 my-8"></div>
<h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
    {{ 'request.overview.submission-details' | translate }}
</h2>
<div class="flex flex-col gap-4" [formGroup]="formGroup">
    <sh-input-text
        formControlName="subject"
        [label]="'request.overview.subject-label' | translate"
        mandatory
    ></sh-input-text>
    <sh-datepicker-accessor
        formControlName="shipmentRequiredByDate"
        [label]="'request.overview.shipment-required-by-date' | translate"
    ></sh-datepicker-accessor>
    <sh-input-text
        formControlName="reason"
        [label]="'request.overview.comments-label' | translate"
        textarea=""
    ></sh-input-text>
    <sh-file-input
        formControlName="files"
        [serverFiles]="serverFiles()"
        (serverFileDownload)="onAttachmentDownload($event)"
        (serverFileDelete)="onAttachmentDelete($event)"
    ></sh-file-input>
    <div
        class="w-full bg-shui-tint-warning-150 border border-solid border-shui-tint-warning-250 rounded-md p-2 box-border"
    >
        <sh-checkbox formControlName="isUrgent" [label]="'request.overview.mark-urgent' | translate"></sh-checkbox>
    </div>
    <sh-checkbox
        formControlName="emailHidingEnabled"
        [label]="'request.overview.hidden-email' | translate"
    ></sh-checkbox>
    <sh-checkbox
        formControlName="informationalOnly"
        [label]="'request.overview.informational-only' | translate"
    ></sh-checkbox>
    <sh-checkbox
        data-testid="create-form-checkbox-refer-out-mdla-team"
        formControlName="directReferOutInternal"
        [label]="'request.overview.direct-refer-out-internal' | translate"
    ></sh-checkbox>
    <sh-checkbox
        data-testid="create-form-checkbox-refer-out-email"
        formControlName="directReferOutExternal"
        [label]="'request.overview.direct-refer-out-external' | translate"
    ></sh-checkbox>
</div>
<div class="flex justify-end gap-2 mt-4">
    @if (requestId()) {
        <sh-button
            [label]="'request.overview.delete' | translate"
            size="max-content"
            color="secondary"
            [disabled]="loading()"
            (click)="onDelete()"
        ></sh-button>
    }
    <sh-button
        [label]="'request.overview.save' | translate"
        size="max-content"
        color="secondary"
        [disabled]="loading()"
        (click)="onSave()"
    ></sh-button>
    <sh-button
        [label]="'request.overview.submit-iro' | translate"
        size="max-content"
        [disabled]="formGroup.invalid || loading()"
        (click)="onSubmit()"
    ></sh-button>
</div>
